import "./HowItWorks.css";

const STEPS = [
  {
    number: "01",
    title: "Talk to us",
    description:
      "Call 01916707697 or email zonayed@carelyit.com and tell us about your organization. We'll walk you through the product and the right plan.",
  },
  {
    number: "02",
    title: "Organization setup",
    description:
      "We set up your organization, branches, and services — then hand owner access over to you.",
  },
  {
    number: "03",
    title: "Activate & go live",
    description:
      "Your subscription plan is activated and your team gets to work. No public registration, no setup headaches.",
  },
];

const HowItWorks = () => (
  <section className="how-it-works">
    <div className="how-it-works__inner">
      <header className="how-it-works__header">
        <p className="how-it-works__eyebrow">How it works</p>
        <h2 className="how-it-works__title">
          Getting started is a conversation, not a form
        </h2>
      </header>

      <ol className="how-it-works__steps">
        {STEPS.map((step) => (
          <li key={step.number} className="how-step">
            <span className="how-step__number" aria-hidden="true">
              {step.number}
            </span>
            <h3 className="how-step__title">{step.title}</h3>
            <p className="how-step__description">{step.description}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
